import clsx from 'clsx';
import { ReactNode } from 'react';

type CustomModalContentProps = {
    children: ReactNode;
    className?: string;
};

const CustomModalContent: React.FC<CustomModalContentProps> = ({
    children,
    className,
}) => (
    <div className={clsx('content-wrapper', className)}>
        <div className='content'>{children}</div>
    </div>
);

export default CustomModalContent;
